/**
 * The recorder's play button, from the video element's own events (spec
 * 13.8). Never from what was asked for: only what the element reports. Pure,
 * for unit tests.
 *
 * - 'paused': the play icon.
 * - 'loading': play was asked for and the element has no frame to show yet
 *   (readyState under 2), or it is waiting for data. A spinner; a tap pauses.
 * - 'playing': the pause icon.
 */
export type PlaybackUi = 'paused' | 'loading' | 'playing';
export type MediaSignal = 'play' | 'playing' | 'pause' | 'ended' | 'waiting' | 'canplay' | 'rejected' | 'emptied';

export function nextPlaybackUi(prev: PlaybackUi, signal: MediaSignal, el: { paused: boolean; readyState: number }): PlaybackUi {
  switch (signal) {
    case 'play': return el.readyState < 2 ? 'loading' : 'playing';
    case 'playing': return 'playing';
    case 'waiting': return el.paused ? 'paused' : 'loading';
    case 'canplay': return prev === 'loading' && !el.paused ? 'playing' : prev;
    case 'pause':
    case 'ended':
    case 'rejected':
    case 'emptied':
      return 'paused';
  }
}
